var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [
        !_vm.past
          ? _c("span", [_vm._v("Nueva Atención")])
          : _c("span", [_vm._v("Atención Realizada")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "attention-type" }, [
        !_vm.past
          ? _c("h4", { staticClass: "is-uppercase" }, [
              _vm._v("Atención a Planificar")
            ])
          : _c("h4", { staticClass: "is-uppercase" }, [
              _vm._v("Atención Realizada")
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control-group" },
          [
            _c("attention-tree", {
              on: {
                "update:action": function($event) {
                  _vm.selectedActionId = $event
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("label", { attrs: { for: "attention-date" } }, [
                _vm._v("\n          Fecha\n          "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedDueBy,
                      expression: "selectedDueBy"
                    }
                  ],
                  staticClass: "attention-date",
                  attrs: { type: "date", name: "attention-date" },
                  domProps: { value: _vm.selectedDueBy },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.selectedDueBy = $event.target.value
                    }
                  }
                })
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.past
        ? _c("div", { staticClass: "responsible" }, [
            _c("h4", { staticClass: "is-uppercase" }, [
              _vm._v("Responsable de la atención")
            ]),
            _vm._v(" "),
            _vm.possibleResponsibleUsersForAttention
              ? _c(
                  "div",
                  { staticClass: "multiselect-container" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "options-list": _vm.possibleResponsibleUsersForAttention
                      },
                      model: {
                        value: _vm.selectedResponsible,
                        callback: function($$v) {
                          _vm.selectedResponsible = $$v
                        },
                        expression: "selectedResponsible"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.messageForResponsible,
                  expression: "messageForResponsible"
                }
              ],
              staticClass: "responsible-message",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                type: "text",
                max: "140",
                placeholder:
                  "Comentario personal para responsable de tarea (máx. 140 caracteres)."
              },
              domProps: { value: _vm.messageForResponsible },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.messageForResponsible = $event.target.value
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("derivation-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.past,
            expression: "!past"
          }
        ],
        attrs: {
          derivations: _vm.derivations,
          userList: _vm.possibleResponsibleUsersForAttention
        },
        on: {
          "update:derivations": function($event) {
            _vm.derivations = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary add",
            class: { "is-loading": _vm.loading },
            attrs: { disabled: !_vm.isValid },
            on: { click: _vm.submit }
          },
          [_vm._v("\n      Agregar\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-outlined cancel",
            attrs: { disabled: _vm.loading },
            on: { click: _vm.cancel }
          },
          [_vm._v("\n      Cancelar\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }